import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-wrh-blue-dark text-white p-4 md:sticky md:bottom-0 z-2 !moblands:static" }
const _hoisted_2 = { class: "mdlg:flex mdlg:items-center mdlg:justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/ryan_group_logo.png",
  width: "141",
  height: "30",
  alt: "Ryan Group Logo",
  class: "mx-auto mdlg:m-0"
}, null, -1)
const _hoisted_4 = { class: "t-10r lg:t-12r 2xl:t-10r my-2 mdlg:px-8 mdlg:my-0" }
const _hoisted_5 = { class: "flex items-center justify-center mdlg:justify-between" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Contact Us")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "px-2" }, "|", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.williamryanhomes.com/terms-and-conditions",
  rel: "noreferrer",
  class: "t-12r whitespace-nowrap mdlg:t-12m",
  target: "_blank"
}, "Terms of Use", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "px-2" }, "|", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.williamryanhomes.com/",
  rel: "noreferrer",
  class: "t-12r whitespace-nowrap mdlg:t-12m",
  target: "_blank"
}, "WilliamRyanHomes.com", -1)

import { Routes } from '@/constants';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString(`©${new Date().getFullYear()} Ryan Building Group. All Rights Reserved. No offer of any kind is made by this website. All prices, plans amenities, and/or promotions are subject to change at any time without notice. Please read the important Terms of Use.`), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: _unref(Routes).CONTACT_US },
          class: "t-12r whitespace-nowrap mdlg:t-12m",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10
      ])
    ])
  ]))
}
}

})